module.exports = "https://web-assets.ifttt.com/packs/media/docs/enable-connection-924d964a.png";